<template>
  <div class="brands wrapper-lg" v-if="letters">
    <div class="brands-count">
      <small>Stocking {{ brandsCount }} brands</small>
    </div>

    <ul class="brands__letters">
      <li
        v-for="(brands, letter) in letters"
        :key="letter"
        class="brands__letters--letter">
        <ul>
          <li class="brands__letter-header">
            <strong class="h1" v-text="letter == '1' ? '0-9' : letter">
            </strong>
          </li>
          <li v-for="brand in brands" :key="brand.id">
            <a
              v-if="brand.in_store"
              :href="`/collections/${brand.handle}`"
              class="brands__letter-brandlink"
              v-text="brand.title"
              :title="brand.title"
              :aria-label="brand.title">
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
  <div class="brands__letters--loading" v-else>
    <Loading :activated="true" />
  </div>
</template>

<script>
import Loading from '../components/Loading.vue';

export default {
  name: 'Brands',

  components: { Loading },

  data() {
    return {
      letters: null,
      brandsCount: 0,
    };
  },

  created() {
    fetch('/collections/all?view=brands-metafields')
      .then((res) => res.json())
      .then((data) => {
        this.letters = data.letters;
        for (const letter in this.letters) {
          if (this.letters[letter]) {
            this.letters[letter].forEach(() => this.brandsCount++);
          }
        }
      });
  },
};
</script>
